import _ from 'lodash';
import React from 'react';

interface Props {
  filterCategories: (key: string) => void;
}

export class SearchCategorie extends React.Component<Props> {
  state = {
    categorie: '',
  };

  private search = _.debounce(() => {
    this.props.filterCategories(this.state.categorie);
  }, 500);

  onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ categorie: event.target.value });
    this.search();
  };

  render() {
    return (
      <div className='ui segment'>
        <div className='ui header'>
          <h3>Filtrar categorias</h3>
        </div>
        <form className='ui form'>
          <div className='field'>
            <label>Buscar</label>
            <input value={this.state.categorie} onChange={this.onSearch} />
          </div>
        </form>
      </div>
    );
  }
}
